import React, { useState } from 'react';
import classNames from 'classnames';

import lang from '../../lib/language';
import { TextHelpers } from '../../lib/util/TextHelpers';

import iconClose from '../../assets/img/close-line.svg';
import IconChevron from '../../assets/img/icon-chevron.svg';
import { ClickableDiv, ClickableImage } from '..';

import styles from './SelectorMobile.module.scss';

type Props = {
    value: string;
    options: any[];
    setSelected: React.Dispatch<React.SetStateAction<string>>;
}

const SelectorMobile = (props: Props) => {
  const { value, options, setSelected } = props;
  const [isOrderTypeMenuOpened, setIsOrderTypeMenuOpened] = useState(false);

  const handleChange = (option: any) => {
    setSelected(option);
    setIsOrderTypeMenuOpened(!isOrderTypeMenuOpened);
  };

  return (
    <div className={styles.wrapperOrderTypeDropDown}>
      <div className={styles.orderTypeTitle}>{lang.commonTradingOrderType()}</div>
      <div className={styles.orderTypeContainer}>
        <div className={styles.orderTypeText}>
          {TextHelpers.getOrderTypeName(value)}
        </div>
        <ClickableImage
          alt=""
          src={IconChevron}
          className={styles.orderTypeSelectIcon}
          onClick={() => { setIsOrderTypeMenuOpened(!isOrderTypeMenuOpened); }}
        />
      </div>
      {isOrderTypeMenuOpened && (
        <div className={styles.wrapperOrderTypeMenu}>
          <ClickableDiv
            className={styles.orderTypeMenuBackground}
            onClick={() => { setIsOrderTypeMenuOpened(!isOrderTypeMenuOpened); }}
          />
            {/* TODO: Separate this part into a component */}
          <div className={styles.orderTypes}>
            <div className={styles.titleWrapper}>
              <span className={styles.title}>{lang.mobileTradingTicketSelectOrderType()}</span>
              <ClickableImage src={iconClose} onClick={() => setIsOrderTypeMenuOpened(false)} />
            </div>
            {options.map((option) => (
              <button
                key={option.value}
                type="button"
                disabled={option.isDisabled}
                className={option.isDisabled ? styles.orderTypeDisabled : styles.orderType}
                onClick={() => { handleChange(option.value); }}
              >
                {option.icon && (
                  <div className={styles.orderTypeIcon}>
                    <img src={option.icon} alt="" />
                  </div>
                )}
                <div className={styles.orderTypeText}>
                  <div className={
                    classNames(styles.orderTypeTitle,
                      { [styles.active]: (!option.isDisabled && option.value === value) })
                  }
                  >
                    {option.text}
                  </div>
                  <div className={
                    classNames(styles.orderTypeDescription,
                      { [styles.active]: (!option.isDisabled && option.value === value) })
                  }
                  >
                    {option.subText}
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SelectorMobile;
